import axios from "axios";
import store from "@/store";
const instance = axios.create({ baseURL: store.getters.server });

export default {
  async getDividaId(id) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/dividas/get/"+id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getDividaDevedor(id) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/dividas/getdevedor/"+id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getDividasAll() {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/dividas/getAll", headers);
      
      response.data.forEach(element => {
        element.ValorDivida = element.ValorDivida?element.ValorDivida.toFixed(2):0.00;
        element.ValorEmpresa = element.ValorEmpresa?element.ValorEmpresa.toFixed(2):0.00;
      });
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getDividas(model) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.post("/dividas/get", model, headers);
      
      response.data.forEach(element => {
        element.ValorDivida = element.ValorDivida?element.ValorDivida.toFixed(2):0.00;
        element.ValorEmpresa = element.ValorEmpresa?element.ValorEmpresa.toFixed(2):0.00;
      });
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getDividas2(model) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.post("/dividas/gett", model, headers);
      
      response.data.forEach(element => {
        element.ValorDivida = element.ValorDivida?element.ValorDivida.toFixed(2):0.00;
        element.ValorEmpresa = element.ValorEmpresa?element.ValorEmpresa.toFixed(2):0.00;
      });
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async save(model) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.post("/dividas/save", model, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async saveStatus(model) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.post("/dividas/saveStatus", model, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  
  async saveDividaImage(model) {
    try {
      const headers = { headers: { 'Content-Type': 'multipart/form-data', "x-access-token": localStorage.getItem("cobranca-token") } };
      let response = await instance.post("/dividas/saveImage", model, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async remove(item) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.delete("/dividas/"+item._id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  
  async removeDividaImage(item, divida) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.delete("/dividas/removeImage/"+item._id+'/'+divida, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/dividas.js